import 'react-app-polyfill/ie11'; // support ie11 (browserslist)
import 'react-app-polyfill/stable'; // support ie11 (browserslist)
import React from 'react';
import { AppContainer } from 'react-hot-loader';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { ConnectedRouter } from 'connected-react-router';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import './helpers/fontawesome';
import configureStore, { history } from './store/configureStore';

import './semantic-ui/semantic.less';
import './semantic-ui/site/collections/toast.less';
import './components/common/micro-frontends/MicroFrontends.less';
import 'reactjs-popup/dist/index.css';
import Highcharts from 'highcharts';

const store = configureStore();

// License is stored in LICENSE.md file
Highcharts.setOptions({
    credits: {
        enabled: false
    },
    lang: {
        thousandsSep: ''
    }
});

const render = () => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <SemanticToastContainer />
                <ConnectedRouter history={history}>
                    <App history={history} />
                </ConnectedRouter>
            </Provider>
        </AppContainer>,
        document.getElementById('app')
    );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

render();

// Hot reloading
if (module.hot) {
    // Reload components
    module.hot.accept('./components/App', () => {
        render();
    });
}
